import ErisHeader from '../../../common/header/ErisHeader';
import ErisFooter from '../../../common/footer/ErisFooter';
import ErisHistoryComponent from './ErisHistoryComponent';

const ErisHistory = () => {
  return (
    <div className="min-w-max px-2">
      <div className="sticky top-0 z-50">
        <ErisHeader />
      </div>
      <main className="py-4">
        <ErisHistoryComponent />
      </main>
      <div className="sticky bottom-0 z-50">
        <ErisFooter />
      </div>
    </div>
  );
};

export default ErisHistory;
